import { useQuery } from "@tanstack/react-query";
import { client } from "./client";

export const useGetUsers = () => {
  const token = localStorage.getItem("accessToken");
  return useQuery({
    queryKey: ["users"],
    queryFn: async () => {
      const response = await client("auth/users", {
        method: "GET",
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined,
        },
      });
      return response;
    },
  });
};
